import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import StepperContainer from './index.style';

type StepperProps = {
  currentStep: number;
  orientation: 'horizontal' | 'vertical';
};

function Stepper({currentStep, orientation = 'horizontal'}: StepperProps) {
  const {t} = useTranslation();
  const [updatedStep, setUpdatedStep] = useState(0);
  const steps = [
    {number: 1, name: t('register.step1.MP_REGISTER_STEP1')},
    {number: 2, name: t('register.step2.MP_REGISTER_TITLE')},
    {number: 3, name: t('register.step3.MP_REGISTER_STEP3')},
    {number: 5, name: t('register.step4.MP_REGISTER_STEP4')},
  ];

  useEffect(() => {
    if (currentStep === 4) {
      setUpdatedStep(3);
    } else {
      setUpdatedStep(currentStep);
    }
  }, [currentStep]);

  return (
    <StepperContainer>
      <div className={`stepper stepper--${orientation}`}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={`stepper__step ${
              index === steps.length - 1 ? 'stepper__step--last' : ''
            }`}>
            <div className='stepper_content'>
              <div
                className={`stepper__node ${
                  updatedStep === step.number
                    ? 'stepper__node--active'
                    : updatedStep > step.number
                    ? 'stepper__node--completed'
                    : ''
                } `}
              />
              {index < steps.length - 1 && (
                <div
                  className={`stepper__line ${
                    updatedStep === step.number ? 'stepper__line--active' : ''
                  }`}
                />
              )}
            </div>
            <div
              className={`stepper__name ${
                updatedStep === step.number ? 'stepper__name--active' : ''
              }`}>
              {step.name}
            </div>
          </div>
        ))}
      </div>
    </StepperContainer>
  );
}

export default Stepper;
